import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

// -- constants
import ViewConstants from 'constants/ViewConstants';
import RoutingEnum from 'constants/RoutingEnum';

import { RouteAction } from 'actions';

// -- entities
import Menu from 'PMT/entities/menu/Menu';
import MenuPart from 'PMT/entities/menu/MenuPart';
import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu';
import MenuPartProduct from 'PMT/entities/menu/MenuPartProduct';
import Product from 'PMT/entities/menu/Product';

// -- views
import ImageLoader from 'PMT/components/ImageLoader';
import MenuPartProductView from './MenuPartProductView';

class MenuPartView extends Component {

  static propTypes = {
    menu: PropTypes.objectOf(Menu).isRequired,

    menuPart: PropTypes.objectOf(MenuPart).isRequired,

    restaurantMenu: PropTypes.objectOf(RestaurantMenu).isRequired,

    currencyCode: PropTypes.string
  };


  shouldComponentUpdate(nextProps) {
    return !nextProps.menuPart.equals(this.props.menuPart)
      || !nextProps.restaurantMenu.equals(this.props.restaurantMenu);
  }

  get menuPart(): MenuPart {
    return this.props.menuPart;
  }

  get restaurantMenu(): RestaurantMenu {
    return this.props.restaurantMenu;
  }

  onEditPartCategoriesClicked = () => {
    RouteAction.redirectTo(RoutingEnum.RESTAURANT_MENU_PART_EDIT, {
      menuId: this.props.menu.id,
      menuPartId: this.menuPart.id,
    });
  };

  // -- renderers

  renderProducts() {
    const productsListView = this.menuPart.products.map((menuPartProduct: MenuPartProduct, index) => {
      const product: Product = this.restaurantMenu.getProductWithId(menuPartProduct.id);

      if (!_.isNull(product)) {
        return (
          <MenuPartProductView
            key={`${product.id}_${index}`}
            product={product}
            menuPartProduct={menuPartProduct}
            currencyCode={this.props.currencyCode}
          />
        );
      }

      return (null);
    });

    return (
      <table className="table top-buffer-20">
        <tbody>
          {productsListView}
        </tbody>
      </table>
    );
  }

  render() {
    return (
      <div className="menu_part_view col-sm-12 col-md-6">
        <h3>{this.menuPart.name}</h3>

        <p>{I18n.tr('menu.min_with_colon')} {this.menuPart.min} | {I18n.tr('menu.max_with_colon')} {this.menuPart.max}</p>

        <button
          className="btn btn btn-default btn-xs"
          onClick={event => {
            event.preventDefault();
            this.onEditPartCategoriesClicked();
          }}
        >
          {I18n.tr('menu.menu_edit.part.edit_part_categories')}
        </button>
        &nbsp;&nbsp;

        {this.renderProducts()}
      </div>
    );
  }

}

export default MenuPartView;



// WEBPACK FOOTER //
// ./scripts/pages/menu/menu/components/MenuPartView.js